export const diffViewerFormatter = (
  previous: object,
  current: object,
  onlyCurrent = false
) => {
  let currentString = JSON.stringify(current, null, 2);
  if (currentString === "undefined") {
    currentString = "";
  }

  if (onlyCurrent) {
    return [currentString, ""];
  }

  let previousString = JSON.stringify(previous, null, 2);
  if (previousString === "undefined") {
    previousString = "";
  }

  return [previousString, currentString];
};
